import React from 'react';
import { List } from 'semantic-ui-react'

import TitDer from '../../../components/funcionales/titder';

const DetalleNivel1 = ({styles, elemento, handleClickidLista}) => {
  return (
    <tr className='' onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaRta?elemento.fechaRta.substr(0, 10):''}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tipo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.numCoti}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.numOrdenCompra}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.nombreUsuarioOC}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEmpresa}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaIni?elemento.fechaIni.substr(0, 10):''}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.estadoOC}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.observaciones}</td>
   </tr>    
  )
};

const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento}
        handleClickidLista={handleClickidLista}
        key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
}; 
const AdminEncuesta2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {

  return (
    <div>
      <List selection>
      <TitDer list={list} textBoton1="Ordenes de compra ejecutadas" btnNuevo={"NO"} styles={styles} handleClick={handleClick} />

      <div>
        <table className='ui blue inverted celled selectable table' style={styles.styTableSup}>
          <thead className=''>
          <tr className=''>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Creada</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Tipo</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Cotización</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>No. Orden</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Responsable</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Cliente</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Fecha de inicio</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>Estado</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Observaciones</th>
            </tr>
          </thead>
          <Lista list={list} handleClickidLista={handleClickidLista}/>
        </table>
        <p></p>
      </div>
      </List>
    </div>
  )
};  

export default AdminEncuesta2